"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateThrowEventViewModel = void 0;
const EventBaseViewModel_1 = require("./EventBaseViewModel");
class IntermediateThrowEventViewModel extends EventBaseViewModel_1.EventViewModel {
    constructor(intermediateThrowEvent, processModel) {
        var _a;
        super(intermediateThrowEvent, processModel);
        this.linkName = (_a = intermediateThrowEvent.linkEventDefinition) === null || _a === void 0 ? void 0 : _a.name;
    }
}
exports.IntermediateThrowEventViewModel = IntermediateThrowEventViewModel;
//# sourceMappingURL=IntermediateThrowEventViewModel.js.map